import {createDiscreteApi} from "naive-ui";


const { message, dialog } = createDiscreteApi(["message","dialog"]);

window.$message = message;
window.$dialog = dialog;

export default message;